import {
  AUTHENTICATING_USER_REQUEST, AUTHENTICATING_USER_SUCCEDDED, AUTHENTICATING_USER_FAILED,
  FETCHING_SSO_URL_REQUEST, FETCHING_SSO_URL_SUCCEEDED, FETCHING_SSO_URL_FAILED, SSO_AUTHENTICATION_FAILED,
  LOGOUT_USER_REQUEST, LOGOUT_USER,
  FETCHING_USER_PROFILE, FETCHING_USER_PROFILE_SUCCEEDED, FETCHING_USER_PROFILE_FAILED,
  USER_REGISTRATION_REQUEST, USER_REGISTRATION_SUCCEDDED, USER_REGISTRATION_FAILED
} from 'constants/actionTypes.jsx';
import { createAction } from "redux-actions";

import { call, put, takeLatest } from 'redux-saga/effects';

import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_URL;

const REGISTRATION_URL = `${apiUrl}/api/2.0/registrations`;


/**
*   User Registration
*/

export const registerUser = createAction(USER_REGISTRATION_REQUEST, (email) => {
  return {
    email: email,
  };
});

const registeringUserSuccedded = createAction(USER_REGISTRATION_SUCCEDDED, (response) => {
  return response;
});

const registeringUserFailed = createAction(USER_REGISTRATION_FAILED, (error) => {
  return error;
});

function* registerUserSaga(action) {
  const { email } = action.payload;


  const registerUserAPI = () => {
    return axios({method: "POST",
      url: REGISTRATION_URL,
      data: email,
    }).then((response) => response.data)
  }; 

  try {
    const response = yield call(registerUserAPI);
    yield put(registeringUserSuccedded(response));
  } catch (error) {
    yield put(registeringUserFailed(error));
  }
}

export default function* usersSaga() {
  yield takeLatest(USER_REGISTRATION_REQUEST, registerUserSaga);
};
